import { IconLockOutlined, IconUnlockOutlined } from "@suse-o11y/icons";
import type { Record } from "@suse-o11y/record";
import React from "react";

import { SkeletonBox } from "~/components/skeleton/box";
import { ZIndexBoundary } from "~/components/z-index-boundary";

import { Api, type DashboardScope } from "../../common/openapi";
import { Tooltip } from "../react/tooltip/Tooltip";

export interface DashboardScopeIconProps {
	dashboardScope: undefined | DashboardScope;
	variant?: "light" | "dark";
	className?: string;
}

export const DashboardScopeIcon: React.FC<DashboardScopeIconProps> = ({
	dashboardScope,
	variant = "dark",
	...props
}) => {
	const DashboardScopeToIcon = {
		[Api.DashboardScope.PublicDashboard]: {
			tooltip: "Public",
			icon: (
				<IconUnlockOutlined className={variant === "dark" ? "text-grey-800" : "text-grey-100"} height={18} width={18} />
			),
		},
		[Api.DashboardScope.PrivateDashboard]: {
			tooltip: "Private",
			icon: (
				<IconLockOutlined className={variant === "dark" ? "text-grey-600" : "text-grey-500"} height={18} width={18} />
			),
		},
	} satisfies Record<DashboardScope>;

	const { tooltip, icon } = DashboardScopeToIcon[dashboardScope ?? Api.DashboardScope.PrivateDashboard];

	return (
		<SkeletonBox when={dashboardScope} {...props}>
			<ZIndexBoundary zIndex={(closestZIndex = 0) => closestZIndex + 50}>
				{(zIndex) => (
					<Tooltip title={tooltip} zIndex={zIndex}>
						{icon}
					</Tooltip>
				)}
			</ZIndexBoundary>
		</SkeletonBox>
	);
};
